import { render, staticRenderFns } from "./StoreMarketingOne.vue?vue&type=template&id=21ea42da&scoped=true"
import script from "./StoreMarketingOne.vue?vue&type=script&lang=js"
export * from "./StoreMarketingOne.vue?vue&type=script&lang=js"
import style0 from "./StoreMarketingOne.vue?vue&type=style&index=0&id=21ea42da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea42da",
  null
  
)

export default component.exports